// extracted by mini-css-extract-plugin
export var did = "FunFact-module__did___f7Nk2";
export var fact = "FunFact-module__fact___ZJBaz";
export var line = "FunFact-module__line___eGp2t";
export var threex = "FunFact-module__threex___GfoiU";